import {
  GSFileSelect,
  GSButton,
  validations,
  GSRadioGroup,
  GSQuickFilter,
} from "golfstatus_react_components";
import {
  faPlus,
  faTimesCircle,
  faQrcode,
  faArrowCircleUp,
} from "@fortawesome/free-solid-svg-icons";
import { getDateTimeYMD } from "../helpers/Dates";
import OrganizationAccessListItem from "../components/access-lists/organization-access-list-item";
import OrganizationAccessCodeItem from "../components/access-lists/organization-access-code-item";

export const accessListForm = (context, list) => {
  if (context) {
    let details = {
      type: "vertical xx-large-gap",
      fields: [
        {
          label: "List Name",
          value: list?.name,
          failedValidation: context?.validationFailed,
          placeholder: "List Name",
          onChange: (e) => context?.updateList?.(e.target.value, "name"),
          isEditable: true,
          maxLength: 50,
          charCount: list?.name?.length,
          required: true,
        },
        {
          label: "List Description",
          value: list?.description,
          failedValidation: context?.validationFailed,
          placeholder: "List Description",
          type: "text-area",
          rows: 5,
          onChange: (e) => context?.updateList?.(e.target.value, "description"),
          maxLength: 240,
          charCount: list?.description?.length,
          isEditable: true,
          required: false,
        },
      ],
    };
    let form = [{ ...details }];
    return form;
  }
};

export const accessListOverviewForm = (context, list) => {
  if (context) {
    let details = {
      type: "vertical",
      title: "Access Codes",
      sectionActions: [
        {
          type: "black no-wrap mobile-icon",
          buttonTitle: "Add Code",
          actionIcon: faPlus,
          actionClick: context.createCode,
        },
      ],
      fields: [
        {
          value: (
            <GSQuickFilter
              getItem={(item) => <OrganizationAccessCodeItem {...item} />}
              itemSelected={context.selectCode}
              getDefaultSearch={context.memberSearch}
              filteredList={context.getFilteredList?.()}
              emptySearchList={context.getEmptySearchList()}
              loading={context.membersAreLoading()}
              loadingMainText="loading codes..."
              searchListType="small-gap grey-empty-list rounded-empty-list"
            />
          ),
          isEditable: true,
          customView: true,
        },
      ],
    };
    let form = [{ ...details }];
    return form;
  }
};

export const accessListUploadForm = (context, validatedCode) => {
  if (context) {
    let fileSelect = {
      type: "vertical xx-large-gap",
      fields: [
        {
          label: "File Upload",
          value: (
            <GSFileSelect
              title={<GSButton buttonIcon={faArrowCircleUp} title="Upload"></GSButton>}
              accept=".xlsx"
              description="Tap or drag an .xls file to upload"
              setSelectedFiles={context.setFile}
              removeSourceItem={context?.removeSourceItem}
            />
          ),
          isEditable: true,
          customView: true,
          required: true
        },
      ],
    };
    if(validatedCode?.identifier){
      fileSelect.fields.push({
        label: "File Preview",
        value: (
          <OrganizationAccessCodeItem {...validatedCode}/>
        ),
        isEditable: false,
        customView: true,
      })
    }

    let form = [{ ...fileSelect }];
    return form;
  }
};

export const removeAccessListForm = (context, list) => {
  if (context) {
    let form = [
      {
        type: "vertical xx-large-gap",
        extras: (
          <div className="delete-member">
            <div className="disclaimer">{`Are you sure you want to delete ${list.name} from your organization? This cannot be undone.`}</div>
            <OrganizationAccessListItem {...list} />
          </div>
        ),
      },
    ];
    return form;
  }
};

export const removeAccessCodeForm = (context, code) => {
  if (context) {
    let form = [
      {
        type: "vertical xx-large-gap",
        extras: (
          <div className="delete-member">
            <div className="disclaimer">{`Are you sure you want to delete ${code.identifier} from your organization? This cannot be undone.`}</div>
            <OrganizationAccessCodeItem {...code} />
          </div>
        ),
      },
    ];
    return form;
  }
};

export const accessCodeForm = (context, code, member) => {
  if (context) {
    const { validEmail } = validations;


    let accessCode = {
      type: "vertical xx-large-gap",
      fields: [
        {
          label: "Access Code",
          value: code?.identifier,
          failedValidation: context?.validationFailed,
          placeholder: "Access Code (Tap Icon to Generate Code)",
          onChange: (e) => context?.updateCode?.(e.target.value, "identifier"),
          isEditable: true,
          hintText:
            "If a code is not provided, one will be automatically generated upon saving.",
          leftIcon: faQrcode,
          leftIconClick: context.generateCode,
          rightIcon: faTimesCircle,
          rightIconClick: () => {
            context.updateCode("", "identifier");
          },
        },
      ],
    };


    let details = {
      type: "vertical xx-large-gap",
      title: "User Details",
      fields: [
        {
          label: "First Name",
          value: member?.firstName,
          failedValidation: context?.validationFailed,
          placeholder: "First Name",
          onChange: (e) => context?.updateMember?.(e.target.value, "firstName"),
          isEditable: true,
          required: false,
        },
        {
          label: "Last Name",
          value: member?.lastName,
          failedValidation: context?.validationFailed,
          placeholder: "Last Name",
          onChange: (e) => context?.updateMember?.(e.target.value, "lastName"),
          isEditable: true,
          required: false,
        },
        {
          label: "Email Address",
          value: member?.email,
          failedValidation: context?.validationFailed,
          placeholder: "Email Address",
          onChange: (e) => context?.updateMember?.(e.target.value, "email"),
          validation: {
            isValid: validEmail,
            invalidLabel: "Not a valid email address",
          },
          isEditable: true,
          required: true,
        },
        {
          label: "Handicap Index",
          value: member?.handicap,
          failedValidation: context?.validationFailed,
          placeholder: "Handicap Index",
          onChange: (e) => context?.updateMember?.(e.target.value, "handicap"),
          isEditable: true,
          required: false,
        },
      ],
    };


    let usage = {
      type: "vertical xx-large-gap",
      title: "Code Usage",
      fields: [
        {
          label: "Code Limit",
          value: (
            <GSRadioGroup
              selectionChanged={(option) => {
                context?.updateCode?.(option, "codeUsage");
              }}
              selectedOption={code?.codeUsage}
              options={[
                { id: 1, label: "Unlimited Use", value: 1 },
                { id: 2, label: "Limited Use", value: 2 },
              ]}
            />
          ),
          customView: true,
          isEditable: context?.isEditable?.(),
        },
      ],
    };


    if (code?.codeUsage?.id === 2) {
      usage.fields.push({
        label: "Uses Per Code",
        value: code?.maxUseQuantity,
        failedValidation: context?.validationFailed,
        placeholder: "Uses Per Code",
        onChange: (e) =>
          context?.updateCode?.(e.target.value, "maxUseQuantity"),
        isEditable: true,
        required: true,
      });
    }

    let codeActivation = {
      type: "vertical xx-large-gap",
      title: "Code Activation",
      fields: [
        {
          label: "Activate On",
          value:
            code?.activateOn !== "" ? getDateTimeYMD(code?.activateOn) : "",
          type: "datetime-local",
          failedValidation: context?.validationFailed,
          onChange: (e) => context?.updateCode?.(e.target.value, "activateOn"),
          isEditable: true,
          required: false,
        },
        {
          label: "Deactivate On",
          value:
            code?.deactivateOn !== "" ? getDateTimeYMD(code?.deactivateOn) : "",
          type: "datetime-local",
          failedValidation: context?.validationFailed,
          onChange: (e) =>
            context?.updateCode?.(e.target.value, "deactivateOn"),
          isEditable: true,
          required: false,
        },
      ],
    };

    let form = [
      { ...accessCode },
      { ...details },
      { ...usage },
      { ...codeActivation },
    ];
    return form;
  }
};
